exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DashedMetric-800a3628{display:inline-block;width:32%;margin-bottom:20px}.DashedMetric-800a3628 .value-1dd53598{font-size:28px;font-weight:500;line-height:34px}.DashedMetric-800a3628 .emptyValue-1cb80a89{color:#BDBDBD}.DashedMetric-800a3628 .label-dd20f9e4{font-size:15px;letter-spacing:0.3px;line-height:16px;margin:3px 0 0 0;color:#424242}.DashedMetric-800a3628.noMargin-3a4ec170{margin-bottom:0px}\n", ""]);

// Exports
exports.locals = {
	"DashedMetric": "DashedMetric-800a3628",
	"value": "value-1dd53598",
	"emptyValue": "emptyValue-1cb80a89",
	"label": "label-dd20f9e4",
	"noMargin": "noMargin-3a4ec170"
};